import { nestApiClient } from './api-client';

export interface BaseInterstitialData {
  name: string;
  description: string;
  cover: string;
  updateKey: string;
}
export interface InterstitialOffer extends BaseInterstitialData {
  id: number;
  suggestedOfferId: string;
  pageName: string;
  isActive: boolean;
  startDate?: string;
  endDate?: string;
}
export interface Survey extends BaseInterstitialData {
  id: number;
  buttonURL: string;
  buttonName: string;
  pageName: string;
  isActive: boolean;
  updateKey: string;
  toShow: boolean;
}
export interface UpsellOffer extends BaseInterstitialData {
  id: number;
  purchasedOfferId: string;
  suggestedOfferId: string;
  startDate: string;
  endDate: string;
}
export interface InterstitialResponse {
  status: string;
  statusCode: number;
  data: {
    offers?: InterstitialOffer[];
    surveys?: Survey[];
    upsells?: UpsellOffer[];
  };
}

export const getInterstitialByPage = () => {
  return nestApiClient.get<InterstitialResponse>('/api/v1/interstitials');
};
